import { render, staticRenderFns } from "./Matcher.vue?vue&type=template&id=235e72c1&scoped=true"
import script from "./Matcher.vue?vue&type=script&lang=js"
export * from "./Matcher.vue?vue&type=script&lang=js"
import style0 from "./Matcher.vue?vue&type=style&index=0&id=235e72c1&prod&lang=scss"
import style1 from "./Matcher.vue?vue&type=style&index=1&id=235e72c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235e72c1",
  null
  
)

export default component.exports